module.exports = __webpack_public_path__ + "img/testimonial_layout2.77d1b96d.png";